// extracted by mini-css-extract-plugin
export var smallSpinner = "_rg-0";